import { useSelector } from 'react-redux';
import { declarationDataSelector } from '../redux/selectors/declarationDataSelector';

const useDeclarationData = () => useSelector(declarationDataSelector);

export default useDeclarationData;
